import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { CreateUserModule } from './create-user/create-user.module';
import { EditUserModule } from './edit-user/edit-user.module';
import { KbManageRegistrationModule } from './kb-manage-registration/kb-manage-registration.module';
import { KbManageUsersModule } from './kb-manage-users/kb-manage-users.module';
import { DeleteUserConfirmDialogComponent } from './delete-user-confirm-dialog/delete-user-confirm-dialog.component';
import { UserRightsDialogComponent } from './user-rights-dialog/user-rights-dialog.component';
import { FormsModule } from '@angular/forms';
import { EditRegistrationUserModule } from './edit-registration-user/edit-registration-user.module';
import { KbCustomerIdDropdownModule } from '../kb-myAccount/kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';

@NgModule({
  declarations: [DeleteUserConfirmDialogComponent, UserRightsDialogComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MediaModule,
    CreateUserModule,
    EditUserModule,
    KbCustomerIdDropdownModule,
    KbManageRegistrationModule,
    KbManageUsersModule,
    EditRegistrationUserModule
  ],
})
export class KbMyCompanyAccountModule {}
